{
  "name": "surveillance",
  "version": "1.64.0-feature-SURVI-3281",
  "license": "MIT",
  "engines": {
    "node": ">=24.15.0 <25",
    "npm": ">=11.6.2 <12"
  },
  "scripts": {
    "ng": "ng",
    "start": "ng serve --host 0.0.0.0 --port 3000 --poll 1000",
    "build-release": "ng build",
    "build-local": "ng build --configuration=local",
    "build-dev": "ng build --configuration=development",
    "build-test": "ng build --configuration=development",
    "build-rc": "ng build --configuration=staging",
    "test": "ng test",
    "test:ci": "ng test --watch=false --coverage",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "compodoc": "npx compodoc -p tsconfig.doc.json"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.1.5",
    "@angular/cdk": "^22.1.5",
    "@angular/common": "^22.1.5",
    "@angular/compiler": "^22.1.5",
    "@angular/core": "^22.1.5",
    "@angular/forms": "^22.1.5",
    "@angular/material": "^22.1.5",
    "@angular/material-moment-adapter": "^22.1.5",
    "@angular/platform-browser": "^22.1.5",
    "@angular/router": "^22.1.5",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^6.0.0",
    "chart.js": "^4.4.3",
    "chartist": "^1.3.0",
    "dayjs": "1.10.7",
    "file-saver": "^2.0.5",
    "jwt-decode": "^4.0.0",
    "moment": "^2.29.1",
    "ng2-charts": "^10.0.0",
    "normalize.css": "^8.0.1",
    "rxjs": "7.8.1",
    "sanitize.css": "^8.0.1",
    "tslib": "^2.0.0",
    "uninstall": "^0.0.0",
    "xlsx": "^0.18.5",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-builders/jest": "^22.0.1",
    "@angular-devkit/build-angular": "^22.1.7",
    "@angular-devkit/core": "^22.1.7",
    "@angular-devkit/schematics": "^22.1.7",
    "@angular/cli": "^22.1.7",
    "@angular/compiler-cli": "^22.1.5",
    "@angular/language-service": "22.1.5",
    "@angular/platform-browser-dynamic": "^22.1.5",
    "@compodoc/compodoc": "^1.1.19",
    "@egjs/hammerjs": "^2.0.17",
    "@types/hammerjs": "^2.0.46",
    "@types/jest": "^30.0.0",
    "@types/jwt-decode": "^3.1.0",
    "@types/node": "^24.13.3",
    "component-emitter": "^2.0.0",
    "jasmine-marbles": "~0.9.2",
    "jasmine-spec-reporter": "~7.0.0",
    "jest": "^30.0.0",
    "jest-environment-jsdom": "^30.5.1",
    "jest-junit": "^16.0.0",
    "jest-preset-angular": "^17.0.0",
    "jsdom": "^26.1.0",
    "keycharm": "^0.4.0",
    "protractor": "~7.0.0",
    "ts-node": "~10.9.0",
    "tslib": "^2.3.0",
    "typescript": "~6.0.3",
    "vis-data": "^8.0.5",
    "vis-util": "^6.0.2"
  }
}
